import React, { useState, useEffect } from "react";
import { Container, Col, Row, Card, CardBody, Table, Button } from "reactstrap";
import { Link } from "react-router-dom";
// Rank images for 1st/2nd/3rd place
import firstPlaceImg from "../../assets/images/items/1st.png";
import secondPlaceImg from "../../assets/images/items/2nd.png";
import thirdPlaceImg from "../../assets/images/items/3rd.png";

// Item images for the top-three description
import ultraLureImg from "../../assets/images/items/ultralure.png";
import superLureImg from "../../assets/images/items/superlure.png";
import lureImg from "../../assets/images/items/lure.png";
import ultraBallImg from "../../assets/images/items/ultraball.png";

import api from "../../api";
// Helper function for thousands separators
function formatNumber(num) {
  return num.toLocaleString();
}

const MapRankings = () => {
  // Page state
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);

  // Current page data
  const [players, setPlayers] = useState([]);

  // Top three data for the description
  const [topThree, setTopThree] = useState([]);

  // Loading / error
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  // Document title
  document.title = "Map Catcher Rankings";

  // ========== Fetch main page data ==========
  useEffect(() => {
    const fetchLeaderboard = async () => {
      setIsLoading(true);
      setError("");
      try {
        // Example: GET /v1/map-catcher-rankings?page=X&limit=Y
        const response = await api.get(
          `/v1/map-catcher-rankings?page=${page}&limit=${limit}`,
          { withCredentials: true },
        );
        // The backend returns { data, page, limit, total }
        const data = response.data.data || [];
        const totalCount = response.data.total || 0;

        setPlayers(data);
        setTotal(totalCount);
      } catch (err) {
        console.error(err);
        setError("Failed to load map catcher leaderboard");
      } finally {
        setIsLoading(false);
      }
    };
    fetchLeaderboard();
  }, [page, limit]);

  // ========== Fetch top three for the description ==========
  useEffect(() => {
    const fetchTopThree = async () => {
      try {
        const response = await api.get(
          "/v1/map-catcher-rankings?page=1&limit=3",
          { withCredentials: true },
        );
        const data = response.data.data || [];
        setTopThree(data);
      } catch (err) {
        console.error("Failed to fetch top three map catchers", err);
      }
    };
    fetchTopThree();
  }, []);

  // ========== Pagination Helpers ==========
  const totalPages = Math.ceil(total / limit);

  const handlePrev = () => {
    if (page > 1) {
      setPage((prev) => prev - 1);
    }
  };

  const handleNext = () => {
    if (page < totalPages) {
      setPage((prev) => prev + 1);
    }
  };

  // ========== Top-3 Description ==========
  // 1st => 1 Ultra Lure + 15 Ultraballs
  // 2nd => 1 Super Lure + 1 Ultraball
  // 3rd => 1 Lure + 5 Ultraballs
  const topThreeDescription =
    topThree.length === 3 ? (
      <div style={{ lineHeight: "1.6", color: "white" }}>
        <p>
          Congratulations to the top 3 map catchers:{" "}
          <strong>{topThree.map((p) => p.username).join(", ")}</strong>.
        </p>
        <p>
          1st place:
          <img
            src={ultraLureImg}
            alt="Ultra Lure"
            style={{
              width: "24px",
              verticalAlign: "middle",
              marginLeft: "5px",
              marginRight: "5px",
            }}
          />
          + 15x{" "}
          <img
            src={ultraBallImg}
            alt="Ultraball"
            style={{
              width: "24px",
              verticalAlign: "middle",
              marginLeft: "5px",
            }}
          />
          <br />
          2nd place: 
          <img
            src={superLureImg}
            alt="Super Lure"
            style={{
              width: "24px",
              verticalAlign: "middle",
              marginLeft: "5px",
              marginRight: "5px",
            }}
          />
          + 10x{" "}
          <img
            src={ultraBallImg}
            alt="Ultraball"
            style={{
              width: "24px",
              verticalAlign: "middle",
              marginLeft: "5px",
            }}
          />
          <br />
          3rd place:
          <img
            src={lureImg}
            alt="Lure"
            style={{
              width: "24px",
              verticalAlign: "middle",
              marginLeft: "5px",
              marginRight: "5px",
            }}
          />
          + 5x{" "}
          <img
            src={ultraBallImg}
            alt="Ultraball"
            style={{
              width: "24px",
              verticalAlign: "middle",
              marginLeft: "5px",
            }}
          />
        </p>
        <p>
          <em>All rewards will be distributed at the end of the day.</em>{" "}
          (Banned or frozen accounts are not included.)
        </p>
      </div>
    ) : (
      "Loading top map catchers..."
    );

  // ========== Rank Image ==========
  const getRankImage = (rank) => {
    if (rank === 1) return firstPlaceImg;
    if (rank === 2) return secondPlaceImg;
    if (rank === 3) return thirdPlaceImg;
    return null;
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col md={12}>
              <Card>
                <CardBody>
                  <h4 className="mb-4">Map Catcher Rankings</h4>

                  {/* Top-3 info
                  <div
                    style={{
                      marginBottom: "20px",
                      padding: "15px",
                      backgroundColor: "#2a2f38",
                      borderRadius: "8px",
                      textAlign: "center",
                      fontSize: "1rem",
                      color: "#333",
                    }}
                  >
                    {topThreeDescription}
                  </div>
 */}
                  {isLoading && <div>Loading leaderboard...</div>}
                  {error && <div className="text-danger">{error}</div>}

                  {!isLoading && !error && (
                    <div>
                      <Table striped responsive className="align-middle">
                        <thead>
                          <tr>
                            <th style={{ width: "5%" }}>Rank</th>
                            <th style={{ width: "10%" }}>Avatar</th>
                            <th>Username</th>
                            <th>Pokemon Caught</th>
                          </tr>
                        </thead>
                        <tbody>
                          {players.map((player, index) => {
                            // rank for this row
                            const rank = (page - 1) * limit + (index + 1);

                            return (
                              <tr key={player.username}>
                                <td>
                                  {rank <= 3 ? (
                                    <img
                                      src={getRankImage(rank)}
                                      alt={`${rank} rank`}
                                    />
                                  ) : (
                                    rank
                                  )}
                                </td>
                                {/* Show the avatar from /avatars/<avatarId>.png */}
                                <td>
                                  <img
                                    src={`/avatars/${player.avatar}.png`}
                                    alt="avatar"
                                    style={{
                                      width: 40,
                                      height: 40,
                                      borderRadius: "50%",
                                    }}
                                  />
                                </td>
                                <td>
                                  {" "}
                                  <Link
                                    to={`/playerprofile?user=${player.username}`}
                                    style={{
                                      textDecoration: "none",
                                      color: "white",
                                    }}
                                  >
                                    {player.username}
                                  </Link>
                                </td>
                                {/* The field that stores how many maps they've caught */}
                                <td>{formatNumber(player.catch_map)}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>

                      {/* Pagination controls */}
                      <div className="d-flex justify-content-between align-items-center mt-3">
                        <div>
                          <Button
                            color="primary"
                            disabled={page <= 1}
                            onClick={handlePrev}
                          >
                            Prev
                          </Button>{" "}
                          <Button
                            color="primary"
                            disabled={page >= totalPages}
                            onClick={handleNext}
                          >
                            Next
                          </Button>
                        </div>
                        <div>
                          Page {page} of {totalPages || 1}
                        </div>
                      </div>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default MapRankings;
